import React from 'react';
import { LTButton, LTFlash, LTText } from '@lambdatestincprivate/lt-components';
import TestMuAIIcon from '../../assets/TestMuAIIcon';

const RCABanner = ({
  rcaData,
  rcaCategory: rcaCategoryFallback,
  isLoading = false,
  onViewRCA,
  onGenerateRCA,
  onViewFailedStep
}) => {
  const parentCategory = rcaData?.parent_failure_category || '';
  const rootCause = rcaData?.root_cause_category || '';
  const dataCategory =
    parentCategory && rootCause
      ? `${parentCategory} \u2192 ${rootCause}`
      : parentCategory || rootCause;
  // Fall back to the instance-level rcaCategory prop when the API payload
  // hasn't been fetched yet (e.g. KaneAI test manager rows know the category
  // before useRCA has resolved the full payload).
  const category = dataCategory || rcaCategoryFallback || '';
  const summary = rcaData?.failure_summary || '';

  const showRcaData = !!(category || summary);
  const showGenerate = !showRcaData && !!onGenerateRCA;

  if (!showRcaData && !showGenerate) return null;

  return (
    <LTFlash
      variant="danger"
      iconComponent={
        <span style={{ padding: '8px', width: '32px', height: '32px' }}>
          <TestMuAIIcon />
        </span>
      }
      text={
        showRcaData ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px'
            }}
          >
            {category && (
              <LTText
                fontSize={LTText.FontSize.FONT_14}
                fontWeight="600"
                color="text.default"
                margin="0"
              >
                {category}
              </LTText>
            )}
            {summary && (
              <LTText
                fontSize={LTText.FontSize.FONT_14}
                fontWeight="400"
                color="text.default"
                margin="0"
              >
                {summary}
              </LTText>
            )}
          </div>
        ) : (
          <LTText
            fontSize={LTText.FontSize.FONT_14}
            fontWeight="600"
            color="text.default"
            margin="0"
          >
            Generate RCA to view the root cause for this failure
          </LTText>
        )
      }
      secondaryAction={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {onViewFailedStep && (
            <LTButton
              variant={LTButton.Variant.INVISIBLE}
              size={LTButton.Size.MEDIUM}
              onClick={onViewFailedStep}
              aria-label="View failed step"
              sx={{
                color: 'danger.fg',
                paddingLeft: '8px',
                paddingRight: '8px',
                paddingTop: 0,
                paddingBottom: 0,
                fontWeight: 400,
                whiteSpace: 'nowrap',
              }}
            >
              View failed step
            </LTButton>
          )}
          <LTButton
            leadingIcon={<TestMuAIIcon />}
            variant={LTButton.Variant.AI}
            size={LTButton.Size.MEDIUM}
            disabled={isLoading}
            onClick={showRcaData ? onViewRCA : onGenerateRCA}
            aria-label={showRcaData ? 'View RCA' : 'Generate RCA'}
            style={{ margin: '6px 0' }}
          >
            {showRcaData ? 'View RCA' : 'Generate RCA'}
          </LTButton>
        </div>
      }
      extraStyles={{
        borderRadius: '6px',
        border: '1px solid',
        borderColor: 'danger.muted',
        width: '100%',
        height: 'auto',
        padding: '8px',
        alignItems: showRcaData ? 'flex-start' : 'center',
        gap: '12px',

        svg: {
          margin: '0px'
        }
      }}
      contentStyles={{
        alignItems: showRcaData ? 'flex-start' : 'center',
        padding: '6px 0'
      }}
    />
  );
};

export default RCABanner;
